import React from 'react';
import { loadable } from '@shared/core/loadableFromNamedExport';
import { CategoryMegaNavPlaceholder } from './CategoryMegaNavPlaceholder';

/**
 * Flag-gated variant: only the bucket that renders it should download it (see AGENTS.md,
 * Bundle / Imports). A same-geometry placeholder stands in while the chunk loads, so the
 * swap causes no layout shift (the flat bar has different dimensions).
 */
export const LazyCategoryMegaNav = loadable(
  () =>
    import(
      /* webpackChunkName: "card/CategoryMegaNav" */
      './CategoryMegaNav'
    ),
  'CategoryMegaNav',
  { fallback: <CategoryMegaNavPlaceholder /> },
);
